import {
  BRANCH_FIELD_FILTER_REQUEST,
  BRANCH_FIELD_FILTER_REQUEST_SUCCESS,
  BRANCH_FIELD_FILTER_REQUEST_FAILURE,
  BRANCH_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const branchFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BRANCH_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BRANCH_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case BRANCH_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BRANCH_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

export default branchFilterFieldsReducer;
